const MOBILE_USER_AGENT = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;

function getRedirectUrl(): string | null {
  const mobileUrl = process.env.REACT_APP_MOBILE_SITE_URL;
  const siteUrl = process.env.REACT_APP_SITE_URL;

  if (!mobileUrl || !siteUrl) return null;

  const isMobile = MOBILE_USER_AGENT.test(navigator.userAgent);
  if (!isMobile) return null;

  const currentHost = window.location.hostname;
  const mobileHost = new URL(mobileUrl).hostname;

  if (currentHost === mobileHost) return null;

  const currentPath = window.location.pathname + window.location.search + window.location.hash;
  const redirectTo = currentPath === "/" || currentPath === "" 
    ? mobileUrl 
    : `${mobileUrl.replace(/\/+$/, '')}${currentPath}`;

  return redirectTo;
}

(function redirectIfMobile() {
  const url = getRedirectUrl();
  if (url) {
    window.location.replace(url);
  }
})();

export {};
